import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import React from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { SurveyForm } from "~/components/specifics/vendors/settings/surveys/form/SurveyForm";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useSurveySettings } from "~/hooks/vendors/useSurveySettings";
import { PATH as SETTING } from "~/pages/vendors/settings";
import { PATH as INDEX } from "~/pages/vendors/settings/surveys/index";
import SettingStyles from "../../SettingStyle.module.scss";

export const Page: React.FC = () => {
	const id = useIdQueryHandler();
	const { data: survey, mutate: mutateSurvey } = useSurveySettings().show(id);
	const handleMutateSurvey = React.useCallback(async () => {
		await mutateSurvey?.();
	}, [mutateSurvey]);
	if (survey?.activatedAt !== null) {
		return null;
	}
	return (
		<VendorSettingLayout>
			<div className={SettingStyles.PcBreadcrumbsWrapper}>
				<Breadcrumbs
					items={[
						{ as: Link, href: INDEX, label: "アンケート設定" },
						{ label: "編集" }
					]}
				/>
			</div>
			<div className={SettingStyles.SpBreadcrumbsWrapper}>
				<Breadcrumbs
					items={[
						{ as: Link, href: SETTING, label: "設定一覧" },
						{ as: Link, href: INDEX, label: "アンケート設定" },
						{ label: "編集" }
					]}
				/>
			</div>
			<Panel>
				<PanelHeader title="アンケート設定" />
				<PanelBody>
					<SurveyForm handleMutate={handleMutateSurvey} survey={survey} />
				</PanelBody>
			</Panel>
		</VendorSettingLayout>
	);
};
